import { render, staticRenderFns } from "./degreeForm.vue?vue&type=template&id=3ac4222c&scoped=true"
import script from "./degreeForm.vue?vue&type=script&lang=js"
export * from "./degreeForm.vue?vue&type=script&lang=js"
import style0 from "./degreeForm.vue?vue&type=style&index=0&id=3ac4222c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac4222c",
  null
  
)

export default component.exports